import React from 'react'
import * as styles from './partner-grid.module.css'

const PartnerGrid = ({ children }) => {
  return (
    <ul className={styles.grid}>
      {children}
    </ul>
  )
}

export default PartnerGrid
